import React, { useState, useEffect } from "react";
import styled from "styled-components";
import heart_plus_40dp_FF9F1F_FILL0_wght400_GRAD0_opsz40 from "../../assets/heart_plus_40dp_FF9F1F_FILL0_wght400_GRAD0_opsz40.png";
import apiService from "../../services/api";
import { usePopup } from "../common/Popup";

const FormContainer = styled.div`
  padding: 10px;
  max-width: 700px;
  margin-left: 50px;
  position: relative;
`;

const FormTitle = styled.h2`
  font-size: 16px;
  color: #FF9F1F;
  font-weight: 600;
  margin-bottom: 20px;
`;

const FormGroup = styled.div`
  margin-bottom: 15px;
`;

const Label = styled.label`
  display: block;
  font-size: 13px;
  color: #002E3B;
  margin-bottom: 5px;
  font-weight: bold;
`;

const Input = styled.input`
  box-sizing: border-box;
  width: 100%;
  padding: 10px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 10px;
  outline: none;
`;

const Select = styled.select`
  box-sizing: border-box;
  width: 100%;
  padding: 10px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 10px;
  outline: none;
  background-color: white;
  color: #002E3B;

  option {
    background-color: white;
    color: #002E3B;
  }
`;

const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #ccc;
  border-radius: 10px;
  padding: 10px;
`;

const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #002E3B;
  cursor: pointer;
  
  input[type="checkbox"] {
    width: 18px;
    height: 18px;
    cursor: pointer;
  }
`;

const Row = styled.div`
  display: flex;
  gap: 20px;
`;

const Column = styled.div`
  flex: ${(props) => (props.flex ? props.flex : 1)};
`;

const Button = styled.button`
  background-color: #6AB8A8;
  color: white;
  font-size: 16px;
  font-weight: bold;
  padding: 8px 20px;
  border: none;
  border-radius: 8px;
  box-shadow: 0px 5px 3px 0px rgba(0, 0, 0, 0.3);
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const ActionsRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 16px;
  margin-top: 24px;
  margin-bottom: 64px;
`;

const VoltarButton = styled.button`
  background-color: #999;
  color: #ffffff;
  border: none;
  padding: 8px 24px;
  font-size: 15px;
  font-weight: 600;
  border-radius: 8px;
  box-shadow: 0px 4px 3px rgba(0, 0, 0, 0.2);
  cursor: pointer;

  &:hover {
    background-color: #888;
  }
`;

const AddEspButton = styled.button`
  background-color: transparent;
  color: #FF9F1F;
  font-size: 16px;
  font-weight: bold;
  padding: 8px 15px;
  border: 1px solid #FF9F1F;
  border-radius: 8px;
  cursor: pointer;
  position: absolute;
  bottom: -40px;
  right: 405px;
  display: flex;
  align-items: center;
  gap: 25px;
`;

const NewSetorInput = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 10px;
  align-items: center;
`;

const VagasEstagioForm = ({ user, estabelecimentos = [], areaCursos = [], onVoltar }) => {
  const popup = usePopup();
  const [formData, setFormData] = useState({
    estabelecimentoSaudeId: user?.estabelecimentoSaudeId ? String(user.estabelecimentoSaudeId) : "",
    especialidadeId: "",
    novaEspecialidadeNome: "",
    areaCursoId: "",
    setor: "",
    unidadeAssistencialId: "",
    novoSetorNome: "",
    qtdVagas: "",
    tipoAtividade: "",
    turno: "",
  });

  const [especialidades, setEspecialidades] = useState([]);
  const [unidadesAssistenciais, setUnidadesAssistenciais] = useState([]);
  const [loadingEspecialidades, setLoadingEspecialidades] = useState(false);
  const [criarNovaEspecialidade, setCriarNovaEspecialidade] = useState(false);
  const [criarNovoSetor, setCriarNovoSetor] = useState(false);

  useEffect(() => {
    console.log('Estabelecimentos recebidos:', estabelecimentos);
    console.log('User estabelecimentoSaudeId:', user?.estabelecimentoSaudeId);
    
    if (estabelecimentos.length > 0) {
      if (estabelecimentos.length === 1) {
        const estabelecimentoId = String(estabelecimentos[0].id);
        console.log('Setando único estabelecimento:', estabelecimentoId);
        setFormData(prev => ({
          ...prev,
          estabelecimentoSaudeId: estabelecimentoId
        }));
        loadEspecialidades(estabelecimentos[0].id);
      } else if (user?.estabelecimentoSaudeId) {
        const estabelecimentoId = String(user.estabelecimentoSaudeId);
        console.log('Setando estabelecimento do usuário:', estabelecimentoId);
        setFormData(prev => ({
          ...prev,
          estabelecimentoSaudeId: estabelecimentoId
        }));
        loadEspecialidades(user.estabelecimentoSaudeId);
      }
    }
  }, [user, estabelecimentos]);

  const loadEspecialidades = async (estabelecimentoSaudeId) => {
    if (!estabelecimentoSaudeId) return;
    
    setLoadingEspecialidades(true);
    try {
      const data = await apiService.getEspecialidades(estabelecimentoSaudeId);
      setEspecialidades(data || []);
    } catch (error) {
      console.error('Erro ao carregar especialidades:', error);
    } finally {
      setLoadingEspecialidades(false);
    }
  };

  const loadUnidadesAssistenciais = async (especialidadeId) => {
    if (!especialidadeId) return;

    try {
      const data = await apiService.getUnidadesAssistenciais(especialidadeId);
      setUnidadesAssistenciais(data || []);
    } catch (error) {
      console.error('Erro ao carregar unidades assistenciais:', error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    if (name === "estabelecimentoSaudeId") {
      console.log('Estabelecimento selecionado:', value);
      setFormData(prevState => ({
        ...prevState,
        [name]: value,
        especialidadeId: "",
        novaEspecialidadeNome: "",
        unidadeAssistencialId: "",
        setor: ""
      }));
      if (value) {
        loadEspecialidades(Number(value));
      }
    } else {
      setFormData(prevState => ({
        ...prevState,
        [name]: value
      }));
    }
  };

  const handleEspecialidadeSelectChange = async (e) => {
    const { value } = e.target;

    if (value === "novo") {
      setCriarNovaEspecialidade(true);
      setFormData(prev => ({
        ...prev,
        especialidadeId: "",
        novaEspecialidadeNome: "",
      }));
      setUnidadesAssistenciais([]);
      return;
    }

    setCriarNovaEspecialidade(false);

    setFormData(prev => ({
      ...prev,
      especialidadeId: value,
      unidadeAssistencialId: "",
    }));

    if (value) {
      await loadUnidadesAssistenciais(Number(value));
    } else {
      setUnidadesAssistenciais([]);
    }
  };

  const handleCriarNovaEspecialidade = async () => {
    if (!formData.novaEspecialidadeNome) {
      await popup.alert({
        icon: "warning",
        message: "Preencha o nome da especialidade.",
      });
      return;
    }

    if (!formData.estabelecimentoSaudeId) {
      await popup.alert({
        icon: "warning",
        message: "Selecione um estabelecimento de saúde antes de criar a especialidade.",
      });
      return;
    }

    try {
      const nova = await apiService.createEspecialidade({
        nome: formData.novaEspecialidadeNome,
        estabelecimentoSaudeId: Number(formData.estabelecimentoSaudeId),
      });

      setEspecialidades(prev => [...prev, nova]);
      setFormData(prev => ({
        ...prev,
        especialidadeId: String(nova.id),
        novaEspecialidadeNome: "",
      }));
      setCriarNovaEspecialidade(false);

      await loadUnidadesAssistenciais(nova.id);
    } catch (error) {
      console.error('Erro ao criar especialidade:', error);
      await popup.alert({
        icon: "warning",
        title: "Erro ao criar especialidade",
        message: error.message || "Tente novamente.",
      });
    }
  };

  const handleSetorChange = (e) => {
    const { value } = e.target;
    if (value === "novo") {
      setCriarNovoSetor(true);
      setFormData(prevState => ({
        ...prevState,
        unidadeAssistencialId: ""
      }));
    } else {
      setCriarNovoSetor(false);
      setFormData(prevState => ({
        ...prevState,
        unidadeAssistencialId: value
      }));
    }
  };

  const handleCriarNovoSetor = async () => {
    if (!formData.novoSetorNome || !formData.especialidadeId) {
      await popup.alert({
        icon: "warning",
        message: "Preencha o nome do setor e selecione uma especialidade.",
      });
      return;
    }

    try {
      const novaUnidade = await apiService.createUnidadeAssistencial({
        nome: formData.novoSetorNome,
        especialidadeId: Number(formData.especialidadeId),
      });

      setUnidadesAssistenciais(prev => [...prev, novaUnidade]);
      setFormData(prevState => ({
        ...prevState,
        unidadeAssistencialId: novaUnidade.id,
        novoSetorNome: ""
      }));
      setCriarNovoSetor(false);
    } catch (error) {
      console.error('Erro ao criar unidade assistencial:', error);
      await popup.alert({
        icon: "warning",
        title: "Erro ao criar setor",
        message: error.message || "Tente novamente.",
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validações
    if (!formData.estabelecimentoSaudeId) {
      await popup.alert({ icon: "warning", message: "Selecione um estabelecimento de saúde." });
      return;
    }

    if (!formData.especialidadeId) {
      await popup.alert({ icon: "warning", message: "Selecione uma especialidade." });
      return;
    }

    if (!formData.areaCursoId) {
      await popup.alert({ icon: "warning", message: "Selecione um curso." });
      return;
    }

    if (!formData.unidadeAssistencialId && !criarNovoSetor) {
      await popup.alert({ icon: "warning", message: "Selecione ou crie um setor." });
      return;
    }

    if (!formData.qtdVagas || Number(formData.qtdVagas) <= 0) {
      await popup.alert({ icon: "warning", message: "Informe a quantidade de vagas." });
      return;
    }

    if (!formData.tipoAtividade) {
      await popup.alert({ icon: "warning", message: "Selecione o tipo de atividade." });
      return;
    }

    if (!formData.turno) {
      await popup.alert({ icon: "warning", message: "Selecione o turno." });
      return;
    }

    // Mapear tipoAtividade para o formato do backend
    const tipoAtividadeMap = {
      "estagio-obrigatorio": "ESTAGIO_OBRIGATORIO",
      "estagio-nao-obrigatorio": "ESTAGIO_SUPERVISIONADO",
      "internato": "INTERNATO_MEDICO",
      "aula-pratica": "AULA_PRATICA"
    };

    try {
      let unidadeAssistencialId = formData.unidadeAssistencialId;

      const vagaData = {
        estabelecimentoSaudeId: Number(formData.estabelecimentoSaudeId),
        unidadeAssistencialId: Number(unidadeAssistencialId),
        areaCursoId: Number(formData.areaCursoId),
        tipoAtividade: tipoAtividadeMap[formData.tipoAtividade] || formData.tipoAtividade,
        quantidade: Number(formData.qtdVagas),
        turno: formData.turno
      };

      const novaVaga = await apiService.createVaga(vagaData);
      console.log('Vaga criada com sucesso:', novaVaga);
      await popup.alert({
        icon: "success",
        message: "Vaga cadastrada com sucesso!",
      });

      setFormData({
        estabelecimentoSaudeId: user?.estabelecimentoSaudeId ? String(user.estabelecimentoSaudeId) : "",
        especialidadeId: "",
        novaEspecialidadeNome: "",
        areaCursoId: "",
        setor: "",
        unidadeAssistencialId: "",
        novoSetorNome: "",
        qtdVagas: "",
        tipoAtividade: "",
        turno: "",
      });
      setCriarNovoSetor(false);
    } catch (error) {
      console.error('Erro ao cadastrar vaga:', error);
      await popup.alert({
        icon: "warning",
        title: "Erro ao cadastrar vaga",
        message: error.message || "Tente novamente.",
      });
    }
  };

  const isAdmin = user?.cargoId === 1;
  const podeSelecionarEstabelecimento = isAdmin && estabelecimentos.length > 1;

  return (
    <FormContainer>
      <FormTitle>
        Preencha os campos. <br/> 
        Para cadastrar novas especialidades, utilize a opção <b><i>+ Criar nova especialidade</i></b>.
      </FormTitle>
      <form onSubmit={handleSubmit}>
        <FormGroup>
          <Label>Estabelecimento de saúde*</Label>
          <Select
            name="estabelecimentoSaudeId"
            value={formData.estabelecimentoSaudeId || ""}
            onChange={handleChange}
            disabled={!podeSelecionarEstabelecimento}
            style={{ cursor: podeSelecionarEstabelecimento ? 'pointer' : 'not-allowed' }}
          >
            <option value="">Selecione um estabelecimento</option>
            {estabelecimentos.map(est => {
              const estId = String(est.id);
              return (
                <option key={est.id} value={estId}>
                  {est.nome}
                </option>
              );
            })}
          </Select>
        </FormGroup>

        <FormGroup>
          <Label>Especialidade*</Label>
          {loadingEspecialidades ? (
            <div>Carregando especialidades...</div>
          ) : (
            <>
              <Select
                name="especialidadeId"
                value={criarNovaEspecialidade ? "novo" : (formData.especialidadeId || "")}
                onChange={handleEspecialidadeSelectChange}
              >
                <option value="">Selecione uma especialidade</option>
                {especialidades.map(esp => (
                  <option key={esp.id} value={String(esp.id)}>
                    {esp.nome}
                  </option>
                ))}
                <option value="novo">+ Criar nova especialidade</option>
              </Select>
              {especialidades.length === 0 && !criarNovaEspecialidade && (
                <div style={{ marginTop: '8px', fontSize: '12px', color: '#666' }}>
                  Nenhuma especialidade cadastrada para este estabelecimento.
                  Use a opção &quot;+ Criar nova especialidade&quot;.
                </div>
              )}
            </>
          )}
        </FormGroup>

        {criarNovaEspecialidade && (
          <FormGroup>
            <NewSetorInput>
              <Input
                type="text"
                placeholder="Nome da nova especialidade"
                value={formData.novaEspecialidadeNome}
                onChange={(e) => setFormData(prev => ({
                  ...prev,
                  novaEspecialidadeNome: e.target.value
                }))}
                style={{ flex: 1 }}
              />
              <Button
                type="button"
                onClick={handleCriarNovaEspecialidade}
                style={{ position: "static", margin: 0 }}
              >
                Criar
              </Button>
            </NewSetorInput>
          </FormGroup>
        )}

        {formData.especialidadeId && (
          <FormGroup>
            <Label>Setor* (Unidade Assistencial)</Label>
            <Select
              name="setor"
              value={criarNovoSetor ? "novo" : formData.unidadeAssistencialId}
              onChange={handleSetorChange}
            >
              <option value="">Selecione um setor</option>
              {unidadesAssistenciais.map(unidade => (
                <option key={unidade.id} value={unidade.id}>
                  {unidade.nome}
                </option>
              ))}
              <option value="novo">+ Criar novo setor</option>
            </Select>

            {criarNovoSetor && (
              <NewSetorInput>
                <Input
                  type="text"
                  placeholder="Nome do novo setor"
                  value={formData.novoSetorNome}
                  onChange={(e) => setFormData(prev => ({
                    ...prev,
                    novoSetorNome: e.target.value
                  }))}
                  style={{ flex: 1 }}
                />
                <Button
                  type="button"
                  onClick={handleCriarNovoSetor}
                  style={{ position: "static", margin: 0 }}
                >
                  Criar
                </Button>
              </NewSetorInput>
            )}
          </FormGroup>
        )}

        <FormGroup>
          <Label>Curso*</Label>
          <Select
            name="areaCursoId"
            value={formData.areaCursoId}
            onChange={handleChange}
          >
            <option value="">Selecione um curso</option>
            {areaCursos.map(curso => (
              <option key={curso.id} value={curso.id}>
                {curso.nome}
              </option>
            ))}
          </Select>
        </FormGroup>

        <Row>
          <Column flex={2}>
            <Label>Quantidade de Vagas*</Label>
            <Input
              type="number"
              name="qtdVagas"
              placeholder=""
              value={formData.qtdVagas}
              onChange={handleChange}
              min="1"
            />
          </Column>
          <Column flex={4}>
            <FormGroup>
              <Label>Tipo de atividade*</Label>
              <Select
                name="tipoAtividade"
                value={formData.tipoAtividade}
                onChange={handleChange}
              >
                <option value="">Selecione uma opção</option>
                <option value="estagio-obrigatorio">Estágio obrigatório</option>
                <option value="estagio-nao-obrigatorio">Estágio supervisionado</option>
                <option value="internato">Internato médico</option>
                <option value="aula-pratica">Aula prática</option>
              </Select>
            </FormGroup>
          </Column>
        </Row>
        
        <Row>
          <Column flex={1}>
            <FormGroup>
              <Label>Turno*</Label>
              <Select
                name="turno"
                value={formData.turno}
                onChange={handleChange}
              >
                <option value="">Selecione uma opção</option>
                <option value="Matutino">Matutino</option>
                <option value="Vespertino">Vespertino</option>
                <option value="Noturno">Noturno</option>
              </Select>
            </FormGroup>
          </Column>
          <Column flex={2}>
          </Column>
        </Row>

        <ActionsRow>
          {onVoltar ? (
            <VoltarButton type="button" onClick={onVoltar}>
              Voltar
            </VoltarButton>
          ) : (
            <span />
          )}
          <Button type="submit">
            Cadastrar
          </Button>
        </ActionsRow>
      </form>
    </FormContainer>
  );
};

export default VagasEstagioForm;
